import { FaArrowRight } from 'react-icons/fa6'
import { contactFormProductOptions } from '../../data/contactPageData'
import { useContactForm } from '../../hooks/useContactForm'
import ProductAccordionSelect from './ProductAccordionSelect'

function ContactFormPanel({ section, formId, formType = 'inquiry' }) {
  const { submitLabel, fields } = section
  const { formData, errors, isSubmitting, handleChange, handleSubmit } = useContactForm(formType)

  const renderField = (field) => {
    const fieldClass = field.half
      ? 'contact-form-block__field contact-form-block__field--half'
      : 'contact-form-block__field'
    const fieldId = `${formId}-${field.name}`
    const hasError = Boolean(errors[field.name])
    const isRequired = field.required !== false

    if (field.type === 'textarea') {
      return (
        <div
          className={`${fieldClass}${hasError ? ' contact-form-block__field--error' : ''}`}
          key={field.name}
        >
          <label htmlFor={fieldId}>{field.label}</label>
          <textarea
            id={fieldId}
            name={field.name}
            rows={5}
            placeholder={field.placeholder}
            value={formData[field.name] || ''}
            onChange={handleChange}
            required={isRequired}
            aria-invalid={hasError}
            aria-describedby={hasError ? `${fieldId}-error` : undefined}
            disabled={isSubmitting}
          />
          {hasError ? (
            <span className="contact-form-block__field-error" id={`${fieldId}-error`}>
              {errors[field.name]}
            </span>
          ) : null}
        </div>
      )
    }

    if (field.type === 'select') {
      return (
        <div
          className={`${fieldClass}${hasError ? ' contact-form-block__field--error' : ''}`}
          key={field.name}
        >
          <label htmlFor={fieldId}>{field.label}</label>
          <ProductAccordionSelect
            id={fieldId}
            name={field.name}
            value={formData[field.name] || []}
            onChange={handleChange}
            options={contactFormProductOptions}
            placeholder={field.placeholder}
            disabled={isSubmitting}
            hasError={hasError}
          />
          {hasError ? (
            <span className="contact-form-block__field-error" id={`${fieldId}-error`}>
              {errors[field.name]}
            </span>
          ) : null}
        </div>
      )
    }

    return (
      <div
        className={`${fieldClass}${hasError ? ' contact-form-block__field--error' : ''}`}
        key={field.name}
      >
        <label htmlFor={fieldId}>{field.label}</label>
        <input
          id={fieldId}
          type={field.type}
          name={field.name}
          placeholder={field.placeholder}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={isRequired}
          aria-invalid={hasError}
          aria-describedby={hasError ? `${fieldId}-error` : undefined}
          disabled={isSubmitting}
          autoComplete={
            field.name === 'name'
              ? 'name'
              : field.name === 'email'
                ? 'email'
                : field.name === 'phone'
                  ? 'tel'
                  : 'off'
          }
        />
        {hasError ? (
          <span className="contact-form-block__field-error" id={`${fieldId}-error`}>
            {errors[field.name]}
          </span>
        ) : null}
      </div>
    )
  }

  return (
    <div className="contact-form-block__panel">
      <form className="contact-form-block__form" onSubmit={handleSubmit} noValidate>
        <div className="contact-form-block__grid">
          {fields.map((field) => renderField(field))}
        </div>

        <button className="contact-form-block__submit" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : submitLabel}
          {!isSubmitting ? <FaArrowRight aria-hidden="true" /> : null}
        </button>
      </form>
    </div>
  )
}

export default ContactFormPanel
